import { ProposalDto } from '../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';
import useLatestProposal from './useLatestProposal';

const useUserVoteForProposal = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { latestProposal } = useLatestProposal();

    const { data, error, mutate } = useSWR(
        interfaceSDK && account && latestProposal
            ? ['userVoteForProposal', account, latestProposal]
            : null,
        async (_, userAddress, latestProposal: ProposalDto) => {
            return interfaceSDK!.get.getUserVote(userAddress, latestProposal.id!);
        }
    );

    const update = async (previousValue?: number) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            const currentVote = currentValue?.choice.reduce(
                (total, vote) => (total += +vote),
                0
            );

            if (currentVote !== previousValue) {
                break;
            }
            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        userVoteForProposal: data,
        isLoading: !error && !data,
        error,
        updateUserVoteForProposal: update,
    };
};

export default useUserVoteForProposal;
